angular.module('dpw.components')
    /**
     * @ngdoc directive
     * @name dpwTooltipInfo
     * @restrict EA
     * @param {expression} initStatus
     * @param {expression} extraClass
     * @param {expression} contentWidth
     * @param {expression} contentHeight
     * @param {expression} tooltipLarge
     *
     * @Example
     * <dpw-tooltip-info>This is a tooltip</dpw-tooltip-info>
     *
     * <!-- For Tooltip whose content is bigger than 4 lines, add `tooltip-large` -->
     * <dpw-tooltip-info content-width="300" tooltip-large>
     *     <p>1 Paragraph.</p>
     *     <p>2 Paragraph.</p>
     *     <p>3 Paragraph.</p>
     *     <p>4 Paragraph.</p>
     *     <p>5 Paragraph.</p>
     * </dpw-tooltip-info>
     */
    .directive('dpwTooltipInfo', ['$timeout', function ($timeout) {
        return {
            restrict: 'EA',
            scope: {
                initStatus: '=',
                extraClass: '@',
                contentWidth: '@',
                contentHeight: '@'
            },
            bindToController: true,
            controllerAs: 'ctrl',
            transclude: true,
            templateUrl: 'dpw-tooltip-info.html',
            controller: ['$transclude', function ($transclude) {
                var vm = this;
                var hideContentTimer;

                vm.isShowContent = vm.initStatus === true;
                vm.displayContent = function () {
                    vm.isShowContent = true;
                    cancelHideContentTimer();
                };

                vm.hideContent = function () {
                    cancelHideContentTimer();
                    hideContentTimer = $timeout(function () {
                        vm.isShowContent = false;
                    }, 200);
                };

                $transclude(function (clone) {
                    vm.content = clone.text();
                })

                function cancelHideContentTimer() {
                    if (hideContentTimer) {
                        $timeout.cancel(hideContentTimer);
                    }
                }
            }],
            link: function (scope, element, attrs) {
                var vm = scope.ctrl;
                var $content = element.find('.dpw-tooltip-info-content');
                var contentWidth = parseInt(vm.contentWidth, 10);
                var contentHeight = parseInt(vm.contentHeight, 10);

                !isNaN(contentWidth) && $content.css('width', contentWidth);
                !isNaN(contentHeight) && $content.css('height', contentHeight);

                vm.large = 'tooltipLarge' in attrs;
            }
        };
    }]);
